/**
 * Data layer Dashboard (US-AE.F9 dead-feature fix · @UC9099) — gọi
 *   GET /v1/admin/dashboard → { kpi, queues, recentActivity }
 * Thay fake data đóng cứng bằng số liệu THẬT. Raw fetch + Bearer (mirror cashflow/api.ts).
 * READ-ONLY. Tiền: aumMinor STRING|null (KHÔNG parseFloat client). Không log token.
 */
import type { AdminDashboardResponse, AdminQueueSummary } from "@goppy/contracts";
import { authedFetch } from "@/lib/auth.js";

class DashboardApiError extends Error {
  readonly status: number;
  constructor(message: string, status: number) {
    super(message);
    this.name = "DashboardApiError";
    this.status = status;
  }
}

function safeMessage(status: number): string {
  if (status === 401) return "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.";
  if (status === 403) return "Bạn không có quyền xem trang này.";
  if (status >= 500) return "Hệ thống đang gặp sự cố. Vui lòng thử lại sau.";
  return "Không thể tải tổng quan. Vui lòng thử lại.";
}

export async function fetchDashboard(): Promise<AdminDashboardResponse> {
  const res = await authedFetch("/admin/dashboard", { method: "GET" });
  if (!res.ok) throw new DashboardApiError(safeMessage(res.status), res.status);
  return (await res.json()) as AdminDashboardResponse;
}

/** Chỉ đếm queue (feed badge Topbar/Sidebar) — nhẹ hơn full dashboard. */
export async function fetchQueueSummary(): Promise<AdminQueueSummary> {
  const res = await authedFetch("/admin/queues/summary", { method: "GET" });
  if (!res.ok) throw new DashboardApiError(safeMessage(res.status), res.status);
  return (await res.json()) as AdminQueueSummary;
}
